import { Injectable } from '@angular/core';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { DataService } from 'app/data.service';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropertyTypeResolverService implements Resolve<any>{

  constructor( private neproseService: DataService, private router: Router) { }

  resolve(): Observable<any> | Observable<never>{
    return this.neproseService.getPropertyTypes().pipe(
      take(1),
      mergeMap(propertyTypes=> {
        if (propertyTypes) {
          if(propertyTypes.propertyTypes){
            return of(propertyTypes.propertyTypes);
          }else{
            this.router.navigate(['']);
          }
        } else {
          this.router.navigate(['']);
        }
      })
    )
  }
}
